import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Icon from '../../../../1stlog-ui/src/components/Icon'

const Wrapper = styled.div`
  margin-left: ${({ level }) => (level > 0 ? 30 : 0)}px;
  margin-top: 5px;
  margin-bottom: 5px;
  position: relative;
`

const Line = styled.div`
  position: absolute;
  top: 0;
  left: -18px;
  width: 18px;
  bottom: ${({ isLast }) => (isLast ? '' : '0')};
  height: ${({ isLast }) => (isLast ? '14px' : '')};
  border-left: 1px solid rgba(0, 0, 0, 0.1);
`

const LineRight = styled.div`
  position: absolute;
  top: 0;
  left: -18px;
  width: 18px;
  height: 9px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`

const TitleWrapper = styled.div`
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
`

const Trace = (props) => {
  const { trace, level } = props

  if (lodash.isEmpty(trace) || !lodash.isArray(trace)) {
    return null
  }

  const [item, ...remaining] = trace

  const { name, description, ztnFull } = item

  return (
    <Wrapper level={level}>
      {level > 0 && (
        <>
          <Line />
          <LineRight />
        </>
      )}
      <TitleWrapper className="d-flex align-items-start" isBold={lodash.isEmpty(remaining)}>
        {/* <div className="mr-2">
          <Icon icon="far fa-chevron-down" />
        </div> */}
        <div className="mr-2 ml-2">{lodash.isEmpty(remaining) ? ztnFull : name}</div>
        <div>{description}</div>
      </TitleWrapper>
      {!lodash.isEmpty(remaining) && <Trace trace={remaining} level={level + 1} />}
    </Wrapper>
  )
}

export default Trace
